// Time labels for the chat inbox and thread.

function sameDay(a, b) {
  return a.getFullYear() === b.getFullYear()
    && a.getMonth() === b.getMonth()
    && a.getDate() === b.getDate();
}

/** "14:05" today, "Yesterday", else a short date. */
export function formatChatTime(iso, locale, t) {
  if (!iso) return '';
  const at = new Date(iso);
  const now = new Date();
  if (sameDay(at, now)) {
    return at.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
  }
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (sameDay(at, yesterday)) return t('chat.yesterday');
  return at.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
}

/** Clock time of one message. */
export function formatMessageTime(iso, locale) {
  return iso ? new Date(iso).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' }) : '';
}

/** Day separator label: "Today", "Yesterday", or a full date. */
export function formatDayLabel(iso, locale, t) {
  const at = new Date(iso);
  const now = new Date();
  if (sameDay(at, now)) return t('chat.today');
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  if (sameDay(at, yesterday)) return t('chat.yesterday');
  return at.toLocaleDateString(locale, { weekday: 'short', day: 'numeric', month: 'short' });
}

export function dayKey(iso) {
  const at = new Date(iso);
  return `${at.getFullYear()}-${at.getMonth()}-${at.getDate()}`;
}
